import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { PILLARS } from "@/constants/business";
import { useDialogs } from "@/context/DialogsContext";

export default function PillarsSection() {
  const { requestEstimate } = useDialogs();

  return (
    <section id="services" data-testid="pillars-section" className="py-14 md:py-20 px-4 md:px-8 max-w-7xl mx-auto">
      <div className="mb-10 max-w-2xl">
        <span className="text-xs uppercase tracking-[0.2em] font-bold text-orange">Nos services</span>
        <h2 className="font-heading font-bold text-3xl md:text-4xl tracking-tight text-navy mt-3">
          Une solution pour chaque besoin de transport
        </h2>
      </div>

      <div className="grid sm:grid-cols-2 gap-4 md:gap-5">
        {PILLARS.map((pillar, i) => (
          <motion.div
            key={pillar.key}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.35, delay: i * 0.05 }}
            data-testid={`pillar-card-${pillar.key}`}
            className="bg-white border border-gray-200 rounded-2xl p-6 md:p-8 flex flex-col hover:border-navy/40 transition-colors"
          >
            <div className="w-12 h-12 rounded-xl bg-navy flex items-center justify-center mb-5">
              <pillar.icon className="w-6 h-6 text-white" />
            </div>
            <h3 className="font-heading font-bold text-xl text-navy mb-2">{pillar.title}</h3>
            <p className="text-sm text-muted-foreground leading-relaxed mb-6 flex-1">{pillar.text}</p>
            <button
              data-testid={`pillar-cta-${pillar.key}`}
              onClick={() => requestEstimate({ type: pillar.estimateType, source: `services-${pillar.key}` })}
              className="inline-flex items-center gap-2 text-sm font-semibold text-orange hover:gap-3 transition-all"
            >
              {pillar.cta} <ArrowRight className="w-4 h-4" />
            </button>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
